import _ from 'lodash';

export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_GLOBAL_FOOTER = 'SET_GLOBAL_FOOTER';
export const GET_COOKIE_NOTIFICATION = 'GET_COOKIE_NOTIFICATION';
export const SET_COOKIE_NOTIFICATION = 'SET_COOKIE_NOTIFICATION';
export const SET_DEFAULT_METADATA = 'SET_DEFAULT_METADATA';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_MACHINES = 'SET_MACHINES';
export const MACHINES_LOADING = 'MACHINES_LOADING';
export const SET_ADDRESS_STATES = 'SET_ADDRESS_STATES';
export const SET_ADDRESS_COUNTRIES = 'SET_ADDRESS_COUNTRIES';
export const CANCEL_ADDRESS_VERIFY = 'CANCEL_ADDRESS_VERIFY';
export const cancelAddressVerify = () => ({
  type: CANCEL_ADDRESS_VERIFY,
});

export const CONFIRM_ADDRESS_VERIFY = 'CONFIRM_ADDRESS_VERIFY';
export const confirmAddressVerify = () => ({
  type: CONFIRM_ADDRESS_VERIFY,
});

export const SET_SHIPPING_INFO_SUCCESS = 'SET_SHIPPING_INFO_SUCCESS';
export const SET_SHIPPING_INFO_ERROR = 'SET_SHIPPING_INFO_ERROR';
export const SET_VALIDATED_POSTAL_INFO = 'SET_VALIDATED_POSTAL_INFO';
export const VALIDATION_COMPLETE = 'VALIDATION_COMPLETE';
export const validationComplete = () => ({
  type: VALIDATION_COMPLETE,
});

export const SET_EMAIL_CAPTURE_STATUS = 'SET_EMAIL_CAPTURE_STATUS';

export const SET_REFERRAL_INFO = 'SET_REFERRAL_INFO';

/** ERRORS * */

/** Preload Error Action * */

// Fatal Errors can be shown with this
export const FATAL_ERROR = 'FATAL_ERROR';
export const fatalError = (message, error) => ({
  type: FATAL_ERROR,
  message,
  error,
});

// Notice Errors can be shown with this - This puts a notification at the top of the page
// to let user know there was a problem and they should try again.
export const PROMISE_ERROR = 'PROMISE_ERROR';
export const promiseError = error => ({
  type: PROMISE_ERROR,
  error,
});
export const CUSTOM_PROMISE_ERROR = 'CUSTOM_PROMISE_ERROR';
export const customPromiseErrorPayload =
  (message = null, status = null, type = CUSTOM_PROMISE_ERROR, data = null) => ({
    data: _.merge({ type }, data),
    message,
    status,
  });
export const customPromiseError =
  (message = null, status = null, type = CUSTOM_PROMISE_ERROR, data = null) => ({
    type: PROMISE_ERROR,
    error: customPromiseErrorPayload(message, status, type, data),
  });

// Errors can be logged without showing a ui error this way
export const LOG_ERROR = 'LOG_ERROR';
export const logError = message => ({
  type: LOG_ERROR,
  message,
});

export const SET_NO_GLOWFORGE_PAGE = 'SET_NO_GLOWFORGE_PAGE';



// WEBPACK FOOTER //
// ./app/common/actions/common.js